<template>
  <div class="index cardshodow">
    <!-- <div id="main" style="width:300px;height:400px"></div> -->
    <!-- 弹幕 -->
    <!-- <div class="bullet_chat">
      <div class="bullet_left"> -->
    <!-- <span><img src="/static/images/horn.png" alt=""></span> -->
    <!-- <my-marquee :lists="lists"></my-marquee>
      </div>
      <div class="bullet_right" >更新日志</div>
    </div> -->
    <!--  -->
    <div class="top">
      <el-row class="canvas_box" :gutter="30">
        <el-col :span="6">
          <div class="canvas_warp gauge_total">
            <div class="title">
              <div class="total_num">
                量表总数：
                <span>{{ dataInfo.scalenum }}</span>
              </div>
              <!-- <div class="total_des">Total number of scales</div> -->
            </div>
            <div class="content">
              <div id="gauge_total" class="canvas"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="canvas_warp hospital_total">
            <div class="title">
              <div class="total_num">
                医院总数：
                <span>{{ dataInfo.hospitalnum }}</span>
              </div>
              <!-- <div class="total_des">Total hospitals</div> -->
            </div>
            <div class="content">
              <div id="hospitals" class="canvas"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="canvas_warp patient_total">
            <div class="title">
              <div class="total_num">
                患者总数：
                <span>{{ dataInfo.patient }}</span>
              </div>
              <!-- <div class="total_des">Total number of patients</div> -->
            </div>
            <div class="content">
              <div id="patients" class="canvas"></div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="canvas_warp other_total">
            <div class="title">
              <div class="total_num">
                测评人次：
                <span>{{ dataInfo.Evaluation }}</span>
              </div>
              <!-- <div class="total_des">Total visits</div> -->
            </div>
            <div class="content">
              <div id="visits" class="canvas"></div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="center">
      <el-row class="canvas_box" :gutter="30">
        <el-col :span="6" class="views_left">
          <div class="canvas_warp left_one">
            <div class="title">
              <div class="total_num">
                无：
                <span>{{ dataInfo.nothing }}</span>
              </div>
            </div>
            <div class="content margin_top">
              <div id="left_one" class="canvas"></div>
            </div>
          </div>
          <div class="canvas_warp bottom left_two">
            <div class="title">
              <div class="total_num">
                轻微：
                <span>{{ dataInfo.slight }}</span>
              </div>
            </div>
            <div class="content margin_top">
              <div id="left_two" class="canvas"></div>
            </div>
            <!-- <div id="left_two"></div> -->
          </div>
        </el-col>
        <el-col :span="12" class="views_center">
          <div class="views">
            <el-tabs v-model="activeName">
              <el-tab-pane label="地理区间" name="first">
                <!---->
                <div id="mapChart" class="chart"></div>
              </el-tab-pane>
              <el-tab-pane label="医院概况" name="second" class="hospitalBox">
                <!-- 医院概况 -->
                <div class="hospital_list">
                  <div
                    :class="{
                      hospital_item: true,
                      active_hospital: item.ID == infos.HospitalID,
                    }"
                    v-for="item in hospitalList"
                    :key="item.ID + item.Code"
                  >
                    <div class="hospital_info">
                      <p class="hospital_name">{{ item.Name }}</p>
                      <p class="hospital_address">{{ item.Address }}</p>
                    </div>
                    <div class="hospital_entrance">
                      <el-button
                        @click="go(item)"
                        size="mini"
                        :disabled="item.ID == infos.HospitalID"
                        >{{ item.ID == infos.HospitalID ? "当前" : "进入" }}</el-button
                      >
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
            <div id="canvas"></div>
          </div>
        </el-col>
        <el-col :span="6" class="views_right">
          <div class="canvas_warp right_one">
            <div class="title">
              <div class="total_num">
                中度：
                <span>{{ dataInfo.moderate }}</span>
              </div>
            </div>
            <div class="content margin_top">
              <div id="right_one" class="canvas"></div>
            </div>
            <!-- <div id="right_one"></div> -->
          </div>
          <div class="canvas_warp right_two bottom">
            <div class="title">
              <div class="total_num">
                重度：
                <span>{{ dataInfo.severe }}</span>
              </div>
            </div>
            <div class="content margin_top">
              <div id="right_two" class="canvas"></div>
            </div>
            <!-- <div id="right_two"></div> -->
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 量表介绍 -->
    <scale-introduce></scale-introduce>
    <div class="bottom"></div>
    <!-- 弹框 -->

    <!--  -->
  </div>
</template>

<script>
// 引入echarts
import echarts from "echarts";
import cityMap from "../../assets/js/china-main-city-map.js";
import axios from "axios";
import { Axios, AsyncAxios } from "@/common/request";
import Vue from "vue";
import myMarquee from "@/views/hospital/marquee";
// import registerAndsetOption from '@/js/echarts-map'
import scaleIntroduce from "@/components/scaleIntroduce"

//中国地图（第一级地图）的ID、Name、Json数据
var chinaId = 100000;
var chinaName = "china";
var chinaJson = null;
//记录父级ID、Name
var mapStack = [];
var parentId = null;
var parentName = null;

//Echarts地图全局变量，主要是在返回上级地图的方法中会用到
var myChart = null;
export default {
  components: {
    myMarquee,
    scaleIntroduce,
  },
  data() {
    return {
      lists: [
        "连雨不知春去",
        "一晴方觉夏深",
        "连雨不知春去",
        "一晴方觉夏深",
        "连雨不知春去",
        "一晴方觉夏深",
        "连雨不知春去",
        "一晴方觉夏深",
        "连雨不知春去",
        "一晴方觉夏深",
        "连雨不知春去",
        "一晴方觉夏深",
        "连雨不知春去",
        "一晴方觉夏深",
        "连雨不知春去",
        "一晴方觉夏深",
      ],
      activeName: "first",
      dataInfo: {},
      hospitalList: [],
      infos: JSON.parse(window.sessionStorage.getItem("info")),
      echartsData: [],
    };
  },
  mounted() {
    this.getEchartsData();
    this.mapChart("mapChart");
    // 初始化echarts实例
    var gauge_total = echarts.init(document.getElementById("gauge_total"));
    var hospitals = echarts.init(document.getElementById("hospitals"));
    var patients = echarts.init(document.getElementById("patients"));
    var visits = echarts.init(document.getElementById("visits"));
    var left_one = echarts.init(document.getElementById("left_one"));
    var left_two = echarts.init(document.getElementById("left_two"));
    var right_one = echarts.init(document.getElementById("right_one"));
    var right_two = echarts.init(document.getElementById("right_two"));
    // 参数
    // 量表统计
    var opt_gauge = {
      xAxis: {
        type: "category",
        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        show: false,
      },
      yAxis: {
        type: "value",
        show: false,
      },
      series: [
        {
          data: [320, 932, 2320, 4200, 5300, 4200, 6500, 7100],
          type: "line",
          itemStyle: {
            normal: {
              color: "#fff",
              lineStyle: {
                color: "#fff",
              },
            },
          },
        },
      ],
    };

    // left_one
    var leftOne = {
      xAxis: {
        type: "category",
        data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        show: false,
      },
      yAxis: {
        type: "value",
        show: false,
      },
      series: [
        {
          data: [280, 922, 3410, 1500, 5300, 1750, 6547, 7500, 4752],
          type: "line",
          itemStyle: {
            normal: {
              color: "#fff",
              lineStyle: {
                color: "#fff",
              },
            },
          },
        },
      ],
    };
    // 医院统计
    var hospitalData = {
      xAxis: {
        type: "category",
        boundaryGap: false,
        show: false,
      },
      yAxis: {
        type: "value",
        boundaryGap: [0, "30%"],
        show: false,
      },
      visualMap: {
        type: "piecewise",
        show: false,
        dimension: 0,
        seriesIndex: 0,
      },
      series: [
        {
          type: "line",
          smooth: 0.6,
          symbol: "none",
          color: "#fff",
          lineStyle: {
            color: "#fff",
            width: 3,
          },
          markLine: {
            symbol: ["none", "none"],
            label: { show: false },
            data: [{ xAxis: 1 }, { xAxis: 3 }, { xAxis: 5 }, { xAxis: 7 }],
          },
          areaStyle: {
            background: "#fff",
          },
          data: [
            ["2019-10-10", 200],
            ["2019-10-11", 400],
            ["2019-10-12", 650],
            ["2019-10-13", 500],
            ["2019-10-14", 250],
            ["2019-10-15", 300],
            ["2019-10-16", 450],
            ["2019-10-17", 300],
            ["2019-10-18", 100],
          ],
        },
      ],
    };
    // left_two
    var leftTwo = {
      xAxis: {
        type: "category",
        boundaryGap: false,
        show: false,
      },
      yAxis: {
        type: "value",
        boundaryGap: [0, "30%"],
        show: false,
      },
      visualMap: {
        type: "piecewise",
        show: false,
        dimension: 0,
        seriesIndex: 0,
      },
      series: [
        {
          type: "line",
          smooth: 0.6,
          symbol: "none",
          color: "#fff",
          lineStyle: {
            color: "#fff",
            width: 3,
          },
          markLine: {
            symbol: ["none", "none"],
            label: { show: false },
            data: [{ xAxis: 1 }, { xAxis: 3 }, { xAxis: 5 }, { xAxis: 7 }],
          },
          areaStyle: {
            background: "#fff",
          },
          data: [
            ["2019-10-10", 200],
            ["2019-10-11", 140],
            ["2019-10-12", 650],
            ["2019-10-13", 784],
            ["2019-10-14", 250],
            ["2019-10-15", 147],
            ["2019-10-16", 450],
            ["2019-10-17", 534],
            ["2019-10-18", 171],
          ],
        },
      ],
    };
    // 患者统计
    var patientsData = {
      xAxis: {
        show: false,
      },
      yAxis: { show: false },
      series: [
        {
          symbolSize: 10,
          data: [
            [10.0, 8.04],
            [8.0, 6.95],
            [13.0, 7.58],
            [9.0, 8.81],
            [11.0, 8.33],
            [14.0, 9.96],
            [6.0, 7.24],
            [4.0, 4.26],
            [12.0, 10.84],
            [7.0, 4.82],
            [5.0, 5.68],
          ],
          type: "scatter",
          itemStyle: {
            normal: {
              color: "#fff",
              lineStyle: {
                color: "#fff",
              },
            },
          },
        },
      ],
    };
    // right_one
    var rightOne = {
      xAxis: {
        show: false,
      },
      yAxis: { show: false },
      series: [
        {
          symbolSize: 10,
          data: [
            [10.0, 8.04],
            [8.0, 6.95],
            [13.0, 7.58],
            [10.0, 8.04],
            [14.0, 6.95],
            [3.0, 7.58],
            [9.0, 8.81],
            [11.0, 8.33],
            [14.0, 9.96],
            [6.0, 7.24],
            [4.0, 4.26],
            [12.0, 10.84],
            [15.0, 5.68],
          ],
          type: "scatter",
          itemStyle: {
            normal: {
              color: "#fff",
              lineStyle: {
                color: "#fff",
              },
            },
          },
        },
      ],
    };
    // 其他统计
    var colors = ["#fff", "#d14a61", "#675bba"];
    var visitsData = {
      color: colors,
      tooltip: {
        trigger: "none",
        axisPointer: {
          type: "cross",
        },
      },
      grid: {
        top: 70,
        bottom: 50,
      },
      xAxis: [
        {
          type: "category",
          show: false,
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: colors[1],
            },
          },
          axisPointer: {
            label: {
              formatter: function (params) {
                return (
                  "访问量  " +
                  params.value +
                  (params.seriesData.length ? "：" + params.seriesData[0].data : "")
                );
              },
            },
          },
          data: [
            "2016-1",
            "2016-2",
            "2016-3",
            "2016-4",
            "2016-5",
            "2016-6",
            "2016-7",
            "2016-8",
            "2016-9",
            "2016-10",
            "2016-11",
            "2016-12",
          ],
        },
        {
          type: "category",
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: "#ddd",
            },
          },

          data: [
            "2020-1",
            "2020-2",
            "2020-3",
            "2020-4",
            "2020-5",
            "2020-6",
            "2020-7",
            "2020-8",
            "2020-9",
            "2020-10",
            "2020-11",
            "2020-12",
          ],
        },
      ],
      yAxis: [
        {
          type: "value",
          show: false,
        },
      ],
      series: [
        {
          name: "2020 访问量",
          type: "line",
          xAxisIndex: 1,
          smooth: true,
          data: [2.6, 5.9, 9.0, 26.4, 28.7, 70.7, 175.6, 182.2, 48.7, 18.8, 6.0, 2.3],
        },
        {
          name: "2016 访问量",
          type: "line",
          smooth: true,
          data: [3.9, 5.9, 11.1, 18.7, 48.3, 69.2, 231.6, 46.6, 55.4, 18.4, 10.3, 0.7],
        },
      ],
    };
    var rightTwo = {
      color: colors,
      tooltip: {
        trigger: "none",
        axisPointer: {
          type: "cross",
        },
      },
      grid: {
        top: 70,
        bottom: 50,
      },
      xAxis: [
        {
          type: "category",
          show: false,
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: colors[1],
            },
          },
          axisPointer: {
            label: {
              formatter: function (params) {
                return (
                  "访问量  " +
                  params.value +
                  (params.seriesData.length ? "：" + params.seriesData[0].data : "")
                );
              },
            },
          },
          data: [
            "2016-1",
            "2016-2",
            "2016-3",
            "2016-4",
            "2016-5",
            "2016-6",
            "2016-7",
            "2016-8",
            "2016-9",
            "2016-10",
            "2016-11",
            "2016-12",
          ],
        },
        {
          type: "category",
          axisTick: {
            alignWithLabel: true,
          },
          axisLine: {
            onZero: false,
            lineStyle: {
              color: "#ddd",
            },
          },

          data: [
            "2020-1",
            "2020-2",
            "2020-3",
            "2020-4",
            "2020-5",
            "2020-6",
            "2020-7",
            "2020-8",
            "2020-9",
            "2020-10",
            "2020-11",
            "2020-12",
          ],
        },
      ],
      yAxis: [
        {
          type: "value",
          show: false,
        },
      ],
      series: [
        {
          name: "2020 访问量",
          type: "line",
          xAxisIndex: 1,
          smooth: true,
          data: [2.6, 5.9, 9.0, 46.4, 28.7, 70.7, 175.6, 12.2, 78.7, 18.8, 6.0, 12.3],
        },
        {
          name: "2016 访问量",
          type: "line",
          smooth: true,
          data: [7.9, 5.9, 11.1, 17.7, 28.3, 69.2, 21.6, 46.6, 45.4, 78.4, 10.3, 7.7],
        },
      ],
    };

    // 中国地图

    // 展示数据
    gauge_total.setOption(opt_gauge);
    hospitals.setOption(hospitalData);
    patients.setOption(patientsData);
    visits.setOption(visitsData);
    left_one.setOption(leftOne);
    left_two.setOption(leftTwo);
    right_one.setOption(rightOne);
    right_two.setOption(rightTwo);

    // 医院信息
    let info = JSON.parse(window.sessionStorage.getItem("info"));
    this.hospitalList = info.Hospitals;
  },
  methods: {
    getEchartsData() {
      Axios("Sys/GetAllStaticData", "post").then((ret) => {
        this.dataInfo = ret.Data;
      });
    },
    /**
     * 返回上一级地图
     */
    back() {
      if (mapStack.length != 0) {
        //如果有上级目录则执行
        var map = mapStack.pop();
        axios.get("./static/json/map/" + map.mapId + ".json", {}).then((response) => {
          const mapJson = response.data;
          registerAndsetOption(myChart, map.mapId, map.mapName, mapJson, false);

          //返回上一级后，父级的ID、Name随之改变
          parentId = map.mapId;
          parentName = map.mapName;
        });
      }
    },
    /**
     * Echarts地图
     */

    mapChart(divid) {
      axios.get("./static/json/map/" + chinaId + ".json", {}).then((response) => {
        const mapJson = response.data;
        chinaJson = mapJson;
        myChart = echarts.init(document.getElementById(divid));
        registerAndsetOption(myChart, chinaId, chinaName, mapJson, false);
        parentId = chinaId;
        parentName = "china";
        myChart.on("click", function (param) {
          var cityId = cityMap[param.name];
          if (cityId) {
            //代表有下级地图
            axios.get("./static/json/map/" + cityId + ".json", {}).then((response) => {
              const mapJson = response.data;
              registerAndsetOption(myChart, cityId, param.name, mapJson, true);
            });
          } else {
            //没有下级地图，回到一级中国地图，并将mapStack清空
            registerAndsetOption(myChart, chinaId, chinaName, chinaJson, false);
            mapStack = [];
            parentId = chinaId;
            parentName = chinaName;
          }
          // $.get('./asset/json/map/'+param.data.id+'.json', function (mapJson,status) {

          //     registerAndsetOption(myChart,param.data.id,param.name,mapJson,true)

          // }).fail(function () {
          //     registerAndsetOption(myChart,chinaId,'china',chinaJson,false)
          // });
        });
      });
    },

    // 选择医院进入
    go(data) {
      this.$confirm("将进入" + data.Name + ", 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          Axios(
            "Login/SelectHospital",
            "post",
            {
              HospitalID: data.ID,
              Token: window.sessionStorage.getItem("token"),
              HospitalName: data.Name,
            },
            this
          ).then((ret) => {
            var info = {
              UserID: ret.Data.UserID,
              LoginName: ret.Data.LoginName,
              UserName: ret.Data.UserName,
              RoleName: ret.Data.RoleName,
              RoleID: ret.Data.RoleID,
              Menus: ret.Data.Menus,
              DepartmentID: ret.Data.DepartmentID,
              DepartmentName: ret.Data.DepartmentName,
              Avatar: ret.Data.Avatar,
              HospitalID: ret.Data.HospitalID,
              HospitalName: ret.Data.HospitalName,
              token: ret.Data.Token,
              Hospitals: ret.Data.Hospitals,
            };
            window.sessionStorage.setItem("token", ret.Data.Token);
            window.sessionStorage.setItem("info", JSON.stringify(ret.Data));
            window.sessionStorage.setItem(
              "Menus",
              JSON.stringify(ret.Data.Menus[0].Menus)
            );
            this.$store.commit("getInfo", info);
            location.reload();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消进入",
          });
        });
    },
  },
};
/**
 *
 * @param {*} myChart
 * @param {*} id        省市县Id
 * @param {*} name      省市县名称
 * @param {*} mapJson   地图Json数据
 * @param {*} flag      是否往mapStack里添加parentId，parentName
 */
function registerAndsetOption(myChart, id, name, mapJson, flag) {
  echarts.registerMap(name, mapJson);
  myChart.setOption({
    series: [
      {
        type: "map",
        map: name,
        itemStyle: {
          normal: {
            areaColor: "rgba(23, 27, 57,0)",
            borderColor: "#1dc199",
            borderWidth: 1,
          },
        },
        data: initMapData(mapJson),
      },
    ],
  });

  if (flag) {
    //往mapStack里添加parentId，parentName,返回上一级使用
    mapStack.push({
      mapId: parentId,
      mapName: parentName,
    });
    parentId = id;
    parentName = name;
  }
}

function initMapData(mapJson) {
  var mapData = [];
  for (var i = 0; i < mapJson.features.length; i++) {
    mapData.push({
      name: mapJson.features[i].properties.name,
      //id:mapJson.features[i].id
    });
  }
  return mapData;
}
</script>

<style lang="less" scoped>
.margin_top {
  margin-top: 40px;
}
.bullet_chat {
  height: 30px;
  margin-bottom: 10px;
  display: flex;
  line-height: 30px;
  .bullet_left {
    width: 95%;
  }
  .bullet_right {
    width: 5%;
    text-align: right;
  }
}
.index {
  padding: 20px  20px 0 20px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  .center {
    margin-top: 20px;

    .canvas_box {
      height: 500px;
      .views {
        padding: 10px;
        height: 490px;
        box-shadow: 0 0 2px 2px rgba(134, 134, 134, 0.2);
        background: #fff;
        border-radius: 10px;
        // #canvas {
        //   width: 100%;
        //   height: 100%;
        // }
      }
      .left_one {
        background: #3dd598;

        #left_one {
          width: 100%;
          height: 100%;
        }
      }
      .left_two {
        // background: #00aced;
        background: #1e88e5;

        #left_two {
          width: 100%;
          height: 100%;
        }
      }
      .right_one {
        background: #ffbc34;

        #right_one {
          width: 100%;
          height: 100%;
        }
      }
      .right_two {
        background: #fc5a5a;

        #right_two {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .canvas_box {
    height: 150px;
    .canvas_warp {
      width: 100%;
      height: 150px;
      color: #fff;
      border-radius: 10px;
      box-shadow: 0 0 2px 2px rgba(134, 134, 134, 0.2);
      .title {
        height: 30px;
        padding: 10px 20px;
        .total_num {
          font-size: 16px;
          span {
            font-size: 20px;
            font-weight: 600;
          }
        }
        // .total_des {
        //   font-size: 15px;
        // }
      }
      .content {
        height: 100px;
        width: 100%;
        position: relative;
        .canvas {
          width: 100%;
          height: 90px;
          position: absolute;
          left: 0;
          bottom: 0;
        }
      }
    }
    // 总数
    .gauge_total {
      background: #20a8d8;
    }
    .hospital_total {
      background: #63c2de;
    }
    .patient_total {
      background: #70e965;
    }
    .other_total {
      background: #f86c6b;
    }
  }
  .views_right,
  .views_left {
    .canvas_warp {
      height: 235px;
    }
    .bottom {
      margin-top: 20px;
    }
  }
}
#mapChart {
  width: 100%;
  height: 450px;
  // background: #000;
}

.hospitalBox {
  padding-top: 25px;
  height: 440px;
  overflow-y: auto;
  box-sizing: border-box;
}
.card {
  outline: none;
  border: none;
  box-shadow: none;
  height: 120px;
  width: 200px;
  -webkit-box-shadow: none !important;
  padding: 0;
  background-color: rgb(94, 190, 64);
  box-sizing: border-box;
  overflow: hidden;
  padding: 10px;
  color: white;
  border-radius: 10px;
  position: relative;
  margin-left: 20px;
  .hospitalTit {
    font-size: 18px;
    font-weight: 600;
  }
  .address {
    font-size: 12px;
  }
  .el-button {
    border: none;
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-weight: 600;
  }
}
.hospital_list {
  display: flex;
  margin-left: 3%;
  flex-wrap: wrap;
  color: #fff;
  .hospital_item {
    width: 31%;
    padding: 10px;
    margin-right: 2%;
    margin-bottom: 2%;
    background-color: rgb(94, 190, 64);
    border-radius: 10px;
    .hospital_info {
      height: 90px;
      // display: flex;
      .hospital_name {
        font-size: 18px;
        font-weight: 600;
        // height: 54px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
      .hospital_address {
        font-size: 12px;
        // height: 36px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }
    }

    .hospital_entrance {
      margin-top: 5px;
      text-align: right;
    }
  }
}
.active_hospital {
  background-color: rgb(62, 131, 41);
}
</style>



// WEBPACK FOOTER //
// src/views/index/mainIndex.vue